const ApiKey = '67703ffb-34cd-4cd5-85eb-4f8c73eab228';

export default ApiKey;